export default {"src":"/_next/static/media/tourismlogo3.23c54119.svg","height":54,"width":161,"blurWidth":0,"blurHeight":0};